module.exports = __webpack_public_path__ + "img/faris.6920c72d.png";